// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
import { attachmentTypesTranslation } from '../constants'
import { AttachmentType, AttachmentTypePt } from '../types'

export const attachmentTypeTranslatePtToEng = (
  payload: AttachmentTypePt,
): AttachmentType => {
  if (payload === null) return null
  return attachmentTypesTranslation.find(i => i[1] === payload)[0]
}

export const attachmentTypeTranslateEngToPt = (
  payload: AttachmentType,
): AttachmentTypePt => {
  if (!payload) return null
  return attachmentTypesTranslation.find(i => i[0] === payload)[1]
}
